import {Component} from "@angular/core";
import {provideEntityModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {SalePeriodSearchModel} from "../sale-period-search.model";
import {SalePeriodEntityModel} from "../sale-period-entity.model";
import {AbstractSearchPage} from "../../../framework/entity/search/search-page/abstract-search-page";

@Component({
    selector: "wbo-sale-period-search-page",
    templateUrl: "./sale-period-search-page.component.html",
    providers: [provideSearchModel(SalePeriodSearchModel), provideEntityModel(SalePeriodEntityModel)]
})
export class SalePeriodSearchPageComponent extends AbstractSearchPage {
    constructor() {
        super();
    }
}
